const GHOST_SEARCH_PLACEHOLDER = "Buscar posts, tags e autores";
const SEARCH_PLACEHOLDER = "Buscar posts";

function updateSearchPlaceholder() {
    document.querySelectorAll(".gh-root-frame iframe").forEach((frame) => {
        try {
            const input = frame.contentDocument?.querySelector(`input[placeholder="${GHOST_SEARCH_PLACEHOLDER}"]`);

            if (input) {
                input.placeholder = SEARCH_PLACEHOLDER;
            }
        } catch {
            // Ignore frames that are not accessible from the theme document.
        }
    });
}

function scheduleSearchPlaceholderUpdate() {
    [0, 50, 150, 300].forEach((delay) => {
        window.setTimeout(updateSearchPlaceholder, delay);
    });
}

export default function initSearch() {
    const observer = new MutationObserver(scheduleSearchPlaceholderUpdate);
    observer.observe(document.body, {childList: true, subtree: true});

    scheduleSearchPlaceholderUpdate();
}
